/* 
 * Click nbfs://nbhost/SystemFileSystem/Templates/Licenses/license-default.txt to change this license
 * Click nbfs://nbhost/SystemFileSystem/Templates/Other/javascript.js to edit this template
 */

import * as SG from '../snap_helper';

export class ZoomByBBOXControl extends  SG.SelectionControl {
    snapGlobeMenu;

    constructor(snapGlobeMenu) {

        super({
            btnId: 'og-globus-menu-selection',
            ignoreTerrain: true,
            autoSelectionHide: true,
            onSelect: function (extent) {
                this._planet.viewExtentArr(extent);
                snapGlobeMenu.reset();
            }
        });

        this.snapGlobeMenu = snapGlobeMenu;

    }
}
